import { render, staticRenderFns } from "./jfimport.vue?vue&type=template&id=7a9f5068&"
import script from "./jfimport.vue?vue&type=script&lang=js&"
export * from "./jfimport.vue?vue&type=script&lang=js&"
import style0 from "./jfimport.vue?vue&type=style&index=0&id=7a9f5068&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports